<h3 class="mb-4 mt-6 text-center text-lg font-bold">
  IQ Observation Context for {{ data.serviceName }}
</h3>
<table
  class="w-full border-collapse bg-white text-left text-sm font-semibold shadow-md"
>
  <thead class="border-b border-gray-300 text-xs uppercase">
    <tr>
      <th class="w-[80px] px-2 py-2">Time</th>
      <th class="min-w-[200px] px-4 py-2">Summary</th>
      <th class="px-6 py-3">Action</th>
    </tr>
  </thead>
  <tbody>
    @for (obs of data.observations; track obs) {
      <tr class="border-b border-gray-200 transition-colors hover:bg-gray-50">
        <td class="w-[80px] whitespace-nowrap px-2 py-2 align-top">
          <div>{{ obs.date | date: 'MM/dd/yyyy' }}</div>
          <div>{{ obs.begin_time }}–{{ obs.end_time }}</div>
        </td>
        <td class="min-w-[200px] px-4 py-2 align-top">{{ obs.summary }}</td>
        <td class="px-6 py-4">
          <span
            [ngClass]="{
              'bg-green-500': obs.action_label === 'Observe',
              'bg-yellow-500': obs.action_label === 'Monitor',
              'bg-orange-500': obs.action_label === 'Investigate',
            }"
            class="inline-block w-20 rounded-full px-2 py-1 text-center text-xs font-semibold text-white"
          >
            {{ obs.action_label }}
          </span>
        </td>
      </tr>
    }
  </tbody>
</table>
<div class="mt-6 flex justify-center pb-6">
  <button
    class="secondary-button small-button px-14 py-3 text-center font-bold"
    style="min-width: 120px"
    (click)="close()"
  >
    CLOSE
  </button>
</div>
